import * as types from "../actions/ActionTypes";

const initialState = {
  brandsList: [],
  brandsDropdownList: [],
  brandRecord: null,
  redirectToList: false,
  validation_error: null,
  showUpdateForm: false,
  showViewPage: false,
  formState: {},
};

const BrandReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.BRANDS_REQUEST:
      return { ...state, redirectToList: false, validation_error: null };

    case types.BRANDS_SUCCESS:
      return { ...state, brandsList: action.brandsList };

    case types.BRANDS_DROPDOWN_SUCCESS:
      return { ...state, brandsDropdownList: action.brandsDropdownList };

    case types.BRANDS_GET_SUCCESS:
      return {
        ...state,
        brandRecord: action.record,
        formState: action.record, // Initialize formState with record data
        showUpdateForm: action.actionType === "update",
        showViewPage: action.actionType === "view",
      };

    case types.BRANDS_VALIDATION_ERROR:
      return { ...state, validation_error: action.validation_error };

    case types.BRANDS_REDIRECT:
      return {
        ...state,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        brandRecord: null,
        formState: {},
        validation_error: null,
      };

    case types.HIDE_BRANDS_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key]) {
        const new_validation_error = { ...state.validation_error };
        delete new_validation_error[action.feild_key];
        return { ...state, validation_error: new_validation_error };
      }
      return state;

    default:
      return state;
  }
};

export default BrandReducer;
